// login.js
import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import img from '../assests/img/chik-logo.png';

export const Logging = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    // If user already logged in, redirect
    const role = localStorage.getItem('role');
    if (role) return <Navigate to="/home" replace />;

    const logingUser = (e) => {
        e.preventDefault();
        setError('');

        if (username === 'admin' && password === 'ch4321') {
            localStorage.setItem('role', 'admin');
            clearForm();
            navigate('/home');
        } else if (username === 'user' && password === 'us1234') {
            localStorage.setItem('role', 'user');
            clearForm();
            navigate('/home');
        } else {
            setError('Invalid username or password');
        }
    };

    const clearForm = () => {
        setUsername('');
        setPassword('');
    };

    return (
        <div className="flex h-screen">
            {/* Left Pane */}
            <div className="hidden lg:flex items-center justify-center flex-1 bg-white text-black">
                <div className="max-w-md text-center">
                    <img src={img} alt="Logo" />
                </div>
            </div>

            {/* Right Pane */}
            <div className="w-full bg-gray-100 lg:w-1/2 flex items-center justify-center">
                <div className="max-w-md w-full p-6">
                    <h1 className="text-3xl font-semibold mb-6 text-black text-center">Sign In</h1>
                    <h2 className="text-sm font-semibold mb-6 text-gray-500 text-center">Welcome to Chicago POS</h2>

                    {error && <p className="text-red-500 mb-4 text-center">{error}</p>}

                    <form onSubmit={logingUser} className="space-y-4 mt-4">
                        <div>
                            <label htmlFor="username" className="block text-sm font-medium text-gray-700">Username</label>
                            <input
                                type="text"
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-gray-300"
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-gray-300"
                                required
                                minLength={4}
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-[#ffa500] text-white p-2 rounded-md hover:bg-gray-800 transition-colors"
                        >
                            Sign In
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};
